import Divider from "@mui/material/Divider";

const StyledDivider = () => {
  return <Divider style={{ marginTop: "24px" }} />;
};

export default StyledDivider;